'use client';
import { createContext, useContext, type ReactNode } from 'react';

const ProductHeadingContext = createContext<'h2' | 'h3'>('h3');

/** Owned listing semantics retain Core's grid, schema and analytics. */
export function ProductHeadingLevel({
  level,
  children,
}: {
  level: 'h2' | 'h3';
  children: ReactNode;
}) {
  return <ProductHeadingContext.Provider value={level}>{children}</ProductHeadingContext.Provider>;
}

export function useProductHeadingLevel() {
  return useContext(ProductHeadingContext);
}
